import { render, staticRenderFns } from "./LivenessDetection.vue?vue&type=template&id=3af4ad00"
import script from "./LivenessDetection.vue?vue&type=script&lang=js"
export * from "./LivenessDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports